/**
 * Țările eMAG pe care poate vinde un client, cu moneda fiecăreia.
 *
 * Trăiește în `shared` ca să fie o singură sursă de adevăr pentru zod, interfață și API —
 * altfel mulțimea valorilor valide s-ar dubla în trei locuri.
 *
 * Adresa API **nu** e aici, ci în `apps/api/src/lib/emag/`: într-acolo se trimit credențialele
 * ca Basic auth, deci nu are ce căuta într-un pachet pe care îl importă și frontend-ul.
 */
export const COUNTRIES = ['RO', 'BG', 'HU'];
/** Moneda în care eMAG facturează și decontează pe fiecare țară. */
export const COUNTRY_CURRENCY = {
    RO: 'RON',
    BG: 'EUR', // Bulgaria a adoptat euro la 01.01.2026 (înainte: BGN)
    HU: 'HUF',
};
export const COUNTRY_LABEL = {
    RO: 'România',
    BG: 'Bulgaria',
    HU: 'Ungaria',
};
export function isCountry(v) {
    return COUNTRIES.includes(v);
}
/** De unde vin facturile de vânzare ale clientului. */
export const INVOICING_MODES = ['emag', 'expertaccounts'];
export const INVOICING_MODE_LABEL = {
    emag: 'eMAG emite facturile (se citesc prin API)',
    expertaccounts: 'Facturarea se face în ExpertAccounts (import „Datorii și creanțe")',
};
//# sourceMappingURL=countries.js.map